export const BEST_AIRLINES_BY_REGION = [
  {
    region: "region_asia",
    airline: "Qatar Airways",
    score: 8.23,
  },
  {
    region: "region_europe",
    airline: "Austrian Airlines",
    score: 7.9,
  },
  {
    region: "region_north_america",
    airline: "American Airlines",
    score: 8.07,
  },
  {
    region: "region_oceania",
    airline: "Qantas",
    score: 8.04,
  },
  {
    region: "region_scandinavia",
    airline: "SAS Scandinavian Airlines",
    score: 8.07,
  },
  {
    region: "region_south_america",
    airline: "American Airlines",
    score: 8.07,
  },
];

export const AIRLINES_COUNTRIES = [
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "BR", name: "Brazil" },
  { code: "CA", name: "Canada" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "GR", name: "Greece" },
  { code: "IS", name: "Iceland" },
  { code: "IE", name: "Ireland" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "ES", name: "Spain" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "UA", name: "Ukraine" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
];

export const DEFAULT_SELECTED_COUNTRY = "US";
